module.exports = __webpack_public_path__ + "img/new-logo-aljay.4047c278.png";